import React, { useEffect, useState } from "react";
import cancel from "assets/icon/cancel.svg";
import search from "assets/icon/search.svg";
import save from "assets/icon/save.svg";
import { Formik } from "formik";
import {
  Button,
  ButtonGroup,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faTimes } from "@fortawesome/free-solid-svg-icons";
import NDCLISTINPUT from "components/NDCLISTINPUT";
import ErrorBoundary from "components/ErrorBoundary";
import { cellRendererCheck } from "utils/columns";
import ReactStrapTable from "components/reactStrapTable";
import DatePicker from "react-datepicker";
import ReactInputMask from "react-input-mask";
import Calendar from "assets/icon/calendar-icon.svg";
import moment from "moment";
import { cloneDeep } from "lodash";
import useAxios from "hooks/useAxios";
import { toast } from "react-toastify";
import Loader from "components/Loader";
import GCNHyperLink from "components/GCNHyperLink";
import Drawer from "components/Drawer";
import NDCAccumulationDetails from "pages/Accumulations/AccumulationsN";

let rSelected1 = "";
let hasDatePopupOpen = false;
let stdateerror = 'Effective Date is a required field'
let endDateError = "Term Date must be Greater Than or Equal to EffectiveDate";
let bupperror = "BUPP is a required field";
let ndcerror = "NDC is a required field";
let ndcDiscerror = "NDC Description is a required field";
const AddCrossWalkDrawer = (props) => {
  const { loading, handelAddMaping, setLoading, orgId, unmappedchargesearch, chargeCodeDetails, setMapingHistoryData,storedDate } = props;
  const API = useAxios();

  const [selectedNdc, setSelectedNdc] = useState("");
  //  const [tableData, setTableData] = useState(dummydata);
  const [checkflag, setCheckFlag] = useState(false);
  const [selectedrow, setSelectedRow] = useState({});
  const [ndcDisc, setNdcDesc] = useState("");
  const [rSelected, setRSelected] = useState("catalog");
  const [ndctabledata, setNdcTabledata] = useState([]);
  const [ndctotalrecords, setNdcTotalRecords] = useState(0);
  const [purschasehistory, setPurchaseHistory] = useState(false)
  const [accRowData, setAccRowData] = useState({});
  const [initialValues, setInitialValues] = useState({
    ...unmappedchargesearch,
  });
  const [NDChideerror, setNDChideerror] = useState('');
  const [startDate, setstartDate] = useState(null);
  const [termdate, setTermDate] = useState(null);
  const [bupp, setBupp] = useState(0);
  const [notes, setNotes] = useState("");
  const [err, setErr] = useState("");
  const [error, seterror] = useState(false);
  const [chargeDisc, setChargeDesc] = useState('');
  const [chargeCode, setChargeCode] = useState('');
  const [gcnflag, setGcnFlag] = useState(false)
  const [gcndata, setGcnData] = useState({})
  const [loder, setloder] = useState(false);
  useEffect(() => {
    if (chargeCodeDetails) {
      setChargeCode(chargeCodeDetails?.chargeCode)
      setChargeDesc(chargeCodeDetails?.chargeDescription)
      rSelected1 = "catalog"
    }
  }, [chargeCodeDetails])

  const handleEffectiveDateRaw = (e) => {
    debugger;
    var val = e.target.value;

    var dt = moment(val, "MM/DD/YYYY", true);
    var isValid = dt.isValid();
    if (isValid == false && startDate !== null) {
      setstartDate(null);
    }

    if (isValid) {
      handleStartDate(e.target.value);
    }
  };
  const handleTermDateRaw = (e) => {
    debugger;
    var val = e.target.value;

    var dt = moment(val, "MM/DD/YYYY", true);
    var isValid = dt.isValid();
    if (isValid == false && startDate !== null) {
      setTermDate(null);
    }
    if (val == "") {
      setTermDate(null)
    }

    if (isValid) {
      handletermdate(e.target.value);
    }
  };
  const fetchHiddenNDCCheck = async (ndc) => {
    debugger;
    setloder(true);
    let accId = unmappedchargesearch.AccumulatorID;
    try {
      const { data } = await API.get(
        `SBTenant/${orgId.tenantID}/CrossWalk/HiddenNDCCheck/${ndc}/${accId}`,
        {
          hasDefaultURL: true,
        }
      );
      debugger
      if (data?.error == true) {
        setNDChideerror(data.message)
      }
      else {
        setNDChideerror('');
      }
      setloder(false);
    } catch {
      setloder(false);
    }
  };
  const handletermdate = (e) => {
    // const enddate = e.target.value;
    // //    // var dt = moment(stDate, "MM/DD/YYYY", true);
    //seterror(true);
    if (e == null) {
      setTermDate(null)
    }
    else {
      setTermDate(new Date(e));
    }
    // if (error == false) {
    //   seterror(false);
    // }
  };
  const handleDateClick = (id) => {
    if (hasDatePopupOpen) {
      hasDatePopupOpen = false;
      return;
    }
    const calendarButton = document.getElementById(id);
    if (calendarButton) {
      calendarButton.click();
      hasDatePopupOpen = true;
    }
  };
  const fetchmapingHistory = async (rowData) => {
    debugger
    let chargeId = chargeCodeDetails?.chargeID;
    setLoading(true);
    try {
      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/Crosswalk/ChargeCodeMappingHistory/${chargeId}`, unmappedchargesearch,
        {
          hasDefaultURL: true,
        }
      );
      if (data?.items?.length > 0) {
        setMapingHistoryData(data.items);
        setLoading(false);
      }
      else {
        setMapingHistoryData([]);
      }
    } catch {
      setLoading(false);
    }
  }
  const handleMouseLeave = () => {
    hasDatePopupOpen = false;
  };
  const handleSubmit = async () => {
    debugger;
    if ((selectedNdc == '' || selectedNdc == undefined) || bupp == 0 || startDate == null || ndcDisc == '' || (termdate != null && (new Date(termdate) < new Date(startDate)))) {
      return seterror(true);
    }
    else {
      // setLoading(true)
      setloder(true);
      let payload = {};
      payload.Chargecode = chargeCode;
      payload.NDC = selectedNdc;
      payload.ChargeDescription = chargeDisc;
      payload.BUPP = bupp;
      payload.Notes = notes;
      payload.DrugDescription = ndcDisc;
      payload.AccumulatorID = chargeCodeDetails?.accumulatorID;
      payload.StartDate = moment(startDate, "MM/DD/YYYY").format("YYYY-MM-DD[T]HH:mm:ss");
      if (termdate != null) {
        payload.EndDate = moment(termdate, "MM/DD/YYYY").format("YYYY-MM-DD[T]HH:mm:ss");
      }
      else {
        payload.EndDate = null;
      }
      payload.ChargeID = 0;
      try {
        const { data } = await API.post(`SBTenant/${orgId.tenantID}/CrossWalk/NewMapping`, payload,
          { hasDefaultURL: true, }
        )
        debugger;
        if (data == true) {
          handelAddMaping();
          toast.success('Mapped successfully');
          fetchmapingHistory(payload)
          //  setErr(data.message)
          // toast.error(data.message);
          // setLoading(false);
          setloder(false);
          //addCrosswalk();
        }
        else {
          setloder(false);


          // addCrosswalk(true);

        }
      }
      catch {
        setloder(false);
      }
    }
  };


  const onSelectndc = async (ndc) => {
    debugger;
    // setErr('');
    if (ndc) {
      setSelectedNdc(ndc);
      setNdcDesc(ndc.description);

      // seterror(false);
      // if(error == false){
      //     seterror(false);

      // }
      fetchGCNHistory();
    } else {
      setSelectedNdc("");
      // setNdcDisc("");
      // if(provider == ''){
      //     setErr('');
      // }
      // if(validationarrmsg.includes(err)){
      //     setErr('');
      // }
    }
  };
  const CellSelectall = (rowData) => {
    return (
      <div className="d-flex align-items-center">{SelectButton(rowData)}</div>
    );
  };
  const SelectButton = (row) => {
    return (
      <Input
        type="radio"
        // className=''
        id="myradio"
        //value={selectedOption}
        style={{ fontSize: "18px", margin: "auto" }}
        onChange={(e) => handlecheckbox(e, row)}
        value={selectedrow}
        checked={selectedrow === row}
        className="mr-1"
      //checked={selectedOption === selectedOption}
      ></Input>
    );
  };
  const handlecheckbox = (e, row) => {
    debugger;
    if (e.target.checked) {
      setSelectedNdc(row.ndc);
      setNdcDesc(row.drugDescription)
      setCheckFlag(true);
      setSelectedRow(row);
      fetchHiddenNDCCheck(row.ndc);
    }

  };
  const cellRenderLink = (row) => {
    return (
      <>
        <span
          className='text-decoration-underline d-inline-block cursor-pointer'
          onClick={() => handelGCN(row)}
        >
          {row.gcnSequenceNumber}
        </span>
      </>
    )
  }
  const handelPurchaseHistory = (rowData) => {
    setPurchaseHistory(!purschasehistory)
    setAccRowData(rowData)

  }
  const cellNDCRenderLink = (row) => {
    return (
      <>
        <span
          className='text-decoration-underline d-inline-block cursor-pointer'
          onClick={() => handelPurchaseHistory(row)}
        >
          {row.ndc}
        </span>
      </>
    )
  }
  const handelGCN = (row) => {
    debugger;
    setGcnFlag(!gcnflag);
    setGcnData(row);
  }
  let mainCol = [
    {
      dataField: "Options",
      text: "Select",
      sort: false,
      width: 80,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => CellSelectall(row),
    },
    {
      dataField: "ndc",
      text: "NDC",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellNDCRenderLink(row),
    },
    {
      dataField: "drugDescription",
      text: "NDC Description",
      sort: false,
      width: 200,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.drugDescription),
    },
    {
      dataField: "packageSize",
      text: "Package Size",
      sort: false,
      width: 200,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.packageSize),
    },
    {
      dataField: "gcnSequenceNumber",
      text: "GCN",
      sort: false,
      width: 180,
      show: rSelected1 === 'fdb' ? true : false,
      inputType: "number",
      hideColFilter: false,
      cellRenderer: (row) => cellRenderLink(row),
    },
    // {
    //   dataField: "unitOfMeasure",
    //   text: "UOM",
    //   sort: true,
    //   width: 200,
    //   show: rSelected === 'fdb' ? true : false,
    // //  show: true,
    //   inputType: "number",
    //   hideColFilter: false,
    //   cellRenderer: (row) => cellRendererCheck(row.unitOfMeasure),
    // },
  ];
  const onClickFilter = (toggle) => {
    debugger;
    setRSelected(toggle);
    rSelected1 = toggle;
    if (ndcDisc != "") {
      fetchNDcDescGCNHistory();
    } else if (selectedNdc) {
      fetchGCNHistory();
    }

  };
  const fetchGCNHistory = async () => {
    debugger;
    let payload = cloneDeep(unmappedchargesearch);

    payload.AccumulatorID = unmappedchargesearch.AccumulatorID;
    //let ndc = selectedNdc;

    setloder(true);
    try {
      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/CrossWalk/GCNHistoryByNDC/${selectedNdc}/${rSelected1}`,
        payload,
        {
          hasDefaultURL: true,
        }
      );
      var da = data;
      if (data.items == null) {
        setNdcTabledata([]);
        setNdcTotalRecords(0);
      }
      if (data?.items?.length > 0) {
        setNdcTabledata(data.items);
        setNdcTotalRecords(data.totalRecords);
      }
      else {
        setNdcTabledata([]);
        setNdcTotalRecords(0);
      }

      setloder(false);
    } catch {
      setloder(false);
    }
  };
  const fetchNDcDescGCNHistory = async () => {
    debugger;
    let payload = cloneDeep(unmappedchargesearch);

    payload.AccumulatorID = unmappedchargesearch.AccumulatorID;
    //let ndc = selectedNdc;

    setloder(true);
    try {
      const { data } = await API.post(
        `SBTenant/${orgId.tenantID}/CrossWalk/GCNHistoryByNDC/${ndcDisc}/${rSelected1}`,
        payload,
        {
          hasDefaultURL: true,
        }
      );
      if (data.items == null) {
        setNdcTabledata([]);
        setNdcTotalRecords(0);
      }
      if (data?.items?.length > 0) {
        setNdcTabledata(data.items);
        setNdcTotalRecords(data.totalRecords);
      }
      else {
        setNdcTabledata([]);
        setNdcTotalRecords(0);
      }

      setloder(false);
    } catch {
      setloder(false);
    }
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      onPageChange(filter);
    }
  };
  const onPageChange = (filter, haveColFilter) => {
    debugger;
    if (haveColFilter) {
      const filterObj = cloneDeep(initialValues);
      filterObj.filters = [...filterObj.filters, ...filter.filters];
      filterObj.currentPage = filter.currentPage;
      filterObj.pageSize = filter.pageSize;
      setInitialValues({
        currentPage: filter.currentPage,
        pageSize: filter.pageSize,
        ...filter,
      });
      // initialValues.currentPage = filter.currentPage;
      // initialValues.pageSize = filter.pageSize;
      // initialValues = { ...initialValues, ...filter };
      debugger;
      fetchGCNHistory();
    } else {
      debugger;

      fetchGCNHistory();
      setInitialValues({ ...initialValues, ...filter });
    }
    //updateStates(crosswalkQueue);
  };
  const handlebupp = (e) => {

    setBupp(e.target.value);
    if (error == false) {
      seterror(false);
    }
    //  seterror(false);
  };

  const handleStartDate = (startDate) => {
    // let stDate = startDate.toISOString();
    // //      let dt =  stDate.substring(0,10)
    // //    // var dt = moment(stDate, "MM/DD/YYYY", true);
    setstartDate(new Date(startDate));

    if (error == false) {
      seterror(false);
    }
    //  seterror(false);
  };

  const handleNdc = (e) => {
    debugger;
    const { value } = e.target;
    if (value) {
      setSelectedNdc(value);
      seterror(false);

    } else {
      setSelectedNdc("");
    }
  };
  const handlendccancel = (value) => {
    setSelectedNdc("");
    setNdcDesc('');
    setNDChideerror('')

  };
  const cancelsearchndcsdisc = () => {
    setSelectedNdc("");
    setNdcDesc('');
    setNDChideerror('')
  };
  const handlendcdisc = (e) => {
    setNdcDesc(e.target.value);
  };
  return (
    <div>
      <Card className="border-0 shadow-top ">
        <CardBody className="section-devider-border">
          <ErrorBoundary>
            <Formik
              initialValues={""}
              onSubmit={handleSubmit}
              // validationSchema={validationSchema}
              // enableReinitialize={true}
              children={(props) => {
                const {
                  isSubmitting,
                  handleSubmit,
                  resetForm,
                  setFieldValue,
                  errors,
                  touched,
                } = props;
                return (
                  <div className="addcrooswalk">
                    <Row>
                      {/* <Col md={4}>
                        <Label style={{}}>NDC Details</Label>
                        <NDCLISTINPUT
                          name="ndc"
                          onSelect={onSelectndc}
                          selectedProvider={selectedNdc}
                        />
                      </Col> */}
                      <Col md={5}>
                        <FormGroup>
                          <Label>NDC</Label>
                          <InputGroup onMouseLeave={handleMouseLeave}>
                            <Input
                              name="ndc"
                              className="required"
                              placeholder="NDC"
                              onChange={handleNdc}
                              value={selectedNdc}
                              autoComplete="off"
                            />
                            <InputGroupText
                            >
                              <span>
                                <FontAwesomeIcon
                                  icon={faSearch}
                                  className="fa-fw"
                                  onClick={fetchGCNHistory}
                                />
                              </span>
                              <span>
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  className="fa-fw"
                                  onClick={handlendccancel}
                                />
                              </span>
                            </InputGroupText>
                          </InputGroup>
                          {/* {error && (selectedNdc == "" || selectedNdc == null) ? (
                      <div
                        className="text-danger f-12"
                        style={{ fontWeight: "bold" }}
                      >
                        {ndcerror}
                      </div>
                    ) : null} */}
                          {/* <NDCList name="ndc"
                      onSelect={(value) => handleNdc(value)}
                      selectedNDC={selectedNdc} selectedRow={selectedRow} /> */}
                        </FormGroup>
                      </Col>
                      <Col md={5}>
                        <FormGroup>
                          <Label>NDC Description</Label>
                          <InputGroup onMouseLeave={handleMouseLeave}>
                            <Input
                              type="text"
                              name="chargeDisc"
                              className="required"
                              placeholder="NDC Description"
                              value={ndcDisc}
                              onChange={handlendcdisc}
                              autoComplete="off"

                            />
                            <InputGroupText
                            >
                              <span>
                                <FontAwesomeIcon
                                  icon={faSearch}
                                  className="fa-fw"
                                  onClick={fetchNDcDescGCNHistory}
                                />
                              </span>
                              <span>
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  className="fa-fw"
                                  onClick={cancelsearchndcsdisc}
                                />
                              </span>
                            </InputGroupText>
                          </InputGroup>
                          {/* {error && (ndcDisc == "" || ndcDisc == null) ? (
                      <div
                        className="text-danger f-12"
                        style={{ fontWeight: "bold" }}
                      >
                        {ndcDiscerror}
                      </div>
                    ) : null} */}
                        </FormGroup>
                      </Col>
                    </Row>
                    <div
                      style={{
                        border: "1px solid #D3D3D3",
                        borderRadius: "4px",

                        marginTop: "10px",
                      }}
                    >
                      <Row
                        className="mt-2 p-3"
                        style={{ border: "1px solid #FEFEFE" }}
                      >
                        <div hidden={true}>
                          <h3
                            className="f-16 font-weight-600"
                            style={{ color: "#702C62" }}
                          >
                            Other Details
                          </h3>
                        </div>
                        <div>
                          <Row>
                            <Col md="3" hidden={true}>
                              <p className="m-0 f-14 ">GCN</p>
                              <p className="m-0 f-14 font-weight-600 mt-1">
                                {selectedNdc?.gcn}
                              </p>
                            </Col>
                            <Col md="3" hidden={true}>
                              <p className="m-0 f-14 ">Package Size</p>
                              <p className="m-0 f-14 font-weight-600 mt-1">
                                {selectedNdc?.drugForm}
                              </p>
                            </Col>
                            <Col md="3" hidden={true}>
                              <p className="m-0 f-14 ">Drug From</p>
                              <p className="m-0 f-14 font-weight-600 mt-1">
                                {selectedNdc?.packageSize}
                              </p>
                            </Col>
                            <Col md="3">
                              <p className="m-0 f-14 ">Toggle</p>
                              <p className="m-0 f-14 font-weight-600 mt-1">
                                <ButtonGroup className="filter-btn-group" >
                                  <Button
                                    color="info"
                                    outline
                                    onClick={() => onClickFilter("fdb")}
                                    active={rSelected === "fdb"}

                                  >
                                    FDB
                                  </Button>
                                  <Button
                                    color="info"
                                    outline
                                    onClick={() => onClickFilter("catalog")}
                                    active={rSelected === "catalog"}
                                  >
                                    Catalog
                                  </Button>
                                </ButtonGroup>
                              </p>
                            </Col>
                          </Row>
                        </div>
                        {loder && <Loader opacity={0.01} />}
                        <div
                          className="table-card scroll-table position-relative border-0 rounded pt-0 mt-3"
                          fixed-height={
                            ndctabledata?.length > 0
                              ? "fixed-height"
                              : "default"
                          }
                        >
                          <ReactStrapTable
                            id="add-other-details"
                            height={550}
                            fixedColumn
                            width={1200}
                            //hasPagination
                            // reset={reset}
                            data={ndctabledata}
                            display={true}
                            columns={mainCol}
                            filters={initialValues}
                            totalRecords={ndctotalrecords}
                            pageSize={initialValues.pageSize}
                            currentPage={initialValues.currentPage}
                            onPageChange={onHandlePageChange}
                            hidefilter={true}
                            showtoggle={false}
                          />
                        </div>
                      </Row>
                    </div>

                    <Row className="mt-1">
                      <Col md={6} className="purchase-date-addcrosswalk">
                        <Label>Effective Date</Label>
                        <FormGroup>
                          <InputGroup
                            onMouseLeave={handleMouseLeave}
                            className="required"
                          >
                            <DatePicker
                              type="date"
                              id="startDate"
                              selected={startDate}
                              onChange={handleStartDate}
                              placeholderText="select a date"
                              name="startDate"
                              onChangeRaw={handleEffectiveDateRaw}
                              dateFormat="MM/dd/yyyy"
                              minDate={new Date(storedDate)}
                              onKeyDown={(e) => e.preventDefault()}
                              autoComplete="off"
                              // customInput={
                              //   <ReactInputMask
                              //     mask="99/99/9999"
                              //   // minDate={new Date(orderDate)}
                              //   // value={startDate}
                              //   // maskChar=''
                              //   />
                              // }
                              // placeholderText={placeholder}
                              className="border-0 w-100 date-picker "
                            />
                            <InputGroupText
                              onClick={() => handleDateClick("startDate")}
                            >
                              <img src={Calendar} alt="" />
                            </InputGroupText>
                          </InputGroup>
                          {(error && startDate == null) ? (
                            <div className="text-danger f-12" style={{ fontWeight: 'bold' }}>
                              {stdateerror}
                            </div>
                          ) : null}
                        </FormGroup>

                      </Col>
                      <Col md={6} className="notrequired-date-endDate-crosswalk">
                        <Label>Term Date</Label>
                        <FormGroup>
                          <InputGroup
                            onMouseLeave={handleMouseLeave}
                            className="required"
                          >
                            <DatePicker
                              type="date"
                              id="termdate"
                              // selected={termdate}
                              selected={termdate}
                              onChange={handletermdate}
                              placeholderText="select a date"
                              name="termdate"
                              openToDate={startDate != null ? new Date(startDate) : false}
                              minDate={startDate != null ? new Date(startDate) : false}
                              onChangeRaw={handleTermDateRaw}
                              dateFormat="MM/dd/yyyy"
                              onKeyDown={(e) => e.preventDefault()}
                              autoComplete="off"
                              isClearable
                              // customInput={
                              //   <ReactInputMask
                              //     mask="99/99/9999"
                              //     // minDate={new Date(orderDate)}
                              //     // value={startDate}
                              //     // maskChar=''
                              //   />
                              // }
                              // placeholderText={placeholder}
                              className="border-0 w-100  "
                            />
                            <InputGroupText
                              onClick={() => handleDateClick("termdate")}
                            >
                              <img src={Calendar} alt="" />
                            </InputGroupText>
                          </InputGroup>
                          {termdate != null && (termdate < startDate) ? (
                            <div className="text-danger f-12" style={{ fontWeight: 'bold' }}>
                              {endDateError}
                            </div>
                          ) : null}
                        </FormGroup>
                      </Col>

                      <Col md={6}>
                        <Label>BUPP</Label>
                        <FormGroup>
                          <Input
                            type="text"
                            className="required"
                            name="bupp"
                            placeholder="Enter BUPP"
                            onChange={handlebupp}
                            autoComplete="off"
                          />
                          {(error && bupp == 0) ? (
                            <div className="text-danger f-12" style={{ fontWeight: 'bold' }}>
                              {bupperror}
                            </div>
                          ) : null}
                        </FormGroup>

                      </Col>
                      <Col md={6}>
                        <Label>Comments</Label>
                        <FormGroup>
                          <Input
                            type="text"
                            className=""
                            name="notes"
                            value={notes}
                            placeholder="Enter Comments"
                            autoComplete="off"
                            onChange={(e) => setNotes(e.target.value)}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    {NDChideerror != "" && <div className="text-danger f-12"
                      style={{ fontWeight: "bold" }}>
                      {NDChideerror}
                    </div>}
                    <Row>
                      <Col
                        md={12}
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <div>
                          <div className="mt-3">
                            <Button
                              color="primary"
                              className="search"
                              onClick={handleSubmit}
                              disabled={!checkflag || NDChideerror != ''}
                            >
                              <span className="right_5">
                                <img src={save} alt="" />
                              </span>{" "}
                              Save
                            </Button>{" "}
                            <Button
                              color="primary"
                              className="reset"
                              onClick={handelAddMaping}
                            >
                              <span className="right_5">
                                <img src={cancel} alt="" />
                              </span>{" "}
                              Cancel
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                );
              }}
            ></Formik>
          </ErrorBoundary>
        </CardBody>
      </Card>
      <Modal
        isOpen={gcnflag}
        toggle={handelGCN}
        size="md"
        className="md"
      >
        <ModalHeader toggle={handelGCN}>
          <h5 className="f-15 text-primary font-weight-700 mt-2">
            NDC List
          </h5>
        </ModalHeader>
        <ModalBody className="m-2 p-2">
          <GCNHyperLink orgId={orgId} gcndata={gcndata} />

        </ModalBody>

      </Modal>
      <Drawer
        direction="end"
        title="Purchase History"
        isOpen={purschasehistory}
        toggle={handelPurchaseHistory}
        size="lg"
      >
        <NDCAccumulationDetails tenantID={orgId} rowData={accRowData} onClose={handelPurchaseHistory} />
      </Drawer>
    </div>
  );
};

export default AddCrossWalkDrawer;
